import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const TruckSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 10.13V7C7 6.45 7.45 6 8 6H16C16.55 6 17 6.45 17 7V10.13C17.9 10.58 18.61 11.12 19 11.7V7C19 5.35 17.65 4 16 4H8C6.35 4 5 5.35 5 7V11.7C5.39 11.12 6.1 10.58 7 10.13Z"
      fill="currentColor"
    />
    <path d="M21.5 13C22.3284 13 23 12.3284 23 11.5C23 10.6716 22.3284 10 21.5 10C20.6716 10 20 10.6716 20 11.5C20 12.3284 20.6716 13 21.5 13Z" fill="currentColor" />
    <path d="M2.5 13C3.32843 13 4 12.3284 4 11.5C4 10.6716 3.32843 10 2.5 10C1.67157 10 1 10.6716 1 11.5C1 12.3284 1.67157 13 2.5 13Z" fill="currentColor" />
    <path
      d="M20 13H18C18 11.51 15 10 12 10C9 10 6 11.51 6 13H4C2.9 13 2 13.9 2 15V20H3C3 21.1 3.9 22 5 22C6.1 22 7 21.1 7 20H17C17 21.1 17.9 22 19
      22C20.1 22 21 21.1 21 20H22V15C22 13.9 21.1 13 20 13ZM5.5 17.5C4.81 17.5 4.25 16.94 4.25 16.25C4.25 15.56 4.81 15 5.5 15C6.19 15 6.75 15.56
      6.75 16.25C6.75 16.94 6.19 17.5 5.5 17.5ZM9 12H11V15.43H9V12ZM14.22 18.7H9.78V16.7H14.22V18.7ZM15 15.43H13V12H15V15.43ZM18.5 17.5C17.81 17.5
      17.25 16.94 17.25 16.25C17.25 15.56 17.81 15 18.5 15C19.19 15 19.75 15.56 19.75 16.25C19.75 16.94 19.19 17.5 18.5 17.5Z"
      fill="currentColor"
    />
  </svg>
);

const Truck = (props: IIconProps) => <Icon component={TruckSvg} {...props} />;

export default Truck;
